// 导入组件
import Vue from "vue";
import Router from "vue-router";
// 登录
import login from "@/views/login";
// 首页
import index from "@/views/index";

// 用户管理
import User from "@/views/user/User";
import UserDetails from "@/views/user/UserDetails";
// 管理员管理
import Admin from "@/views/system/Admin";

//轮播图管理
import Carousel from "@/views/manage/carousel/index";

//广告套餐管理
import AdvertisingPackages from "@/views/manage/advertisingPackages/index";

//公告设置管理
import Announcement from "@/views/manage/announcement/index";

//承诺书设置管理
import Commitment from "@/views/manage/commitment/index";

//承诺书审核管理
import CommitmentAduit from "@/views/manage/commitment/aduit";

//模板演示分类管理
import Category from "@/views/manage/category/index";

//自定义设置管理
import Customize from "@/views/manage/customize/index";

//热门队伍设置
import HotTeam from "@/views/manage/hotTeam/index";

//手续费设置
import Premium from "@/views/manage/premium/index";

// 队伍最大金额限制管理
import Teamlimit from "@/views/manage/teamlimit/index";

// 提现记录统计管理 
import TeamPayout from "@/views/manage/teamPayout/index";

// 队伍订单管理 
import TeamOrder from "@/views/manage/teamOrder/index";

// 队伍管理
import Team from "@/views/manage/team/index";

// 队伍提现金额手续费管理
import PremiumList from "@/views/manage/team/premiumList";

// 队伍管理员管理
import TeamAdmin from "@/views/manage/team/admin";

// 管理员常见问题设置管理
import Fag from "@/views/manage/fag/index";

// 银行卡手动提现审核管理
import TeamManualPayout from "@/views/manage/teamManualPayout/index";

// 版本更新记录
import Versionrecord from "@/views/manage/versionrecord/index";

// 启用路由
Vue.use(Router);
// 导出路由
export default new Router({
  routes: [
    {
      path: "/",
      name: "",
      component: login,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: "/login",
      name: "登录",
      component: login,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: "/index",
      name: "首页",
      component: index,
      iconCls: "el-icon-tickets",
      children: [
        {
          path: "/User/User",
          name: "用户管理",
          component: User,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/User/UserDetails",
          name: "用户详情",
          component: UserDetails,
          meta: {
            requireAuth: true
          }
        },
        
        {
          path: "/system/Admin",
          name: "管理员管理",
          component: Admin,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage/carousel/index",
          name: "轮播图管理",
          component: Carousel,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage/advertisingPackages/index",
          name: "广告套餐设置管理",
          component: AdvertisingPackages,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage/announcement/index",
          name: "公告设置管理",
          component: Announcement,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage/commitment/index",
          name: "承诺书审核管理",
          component: Commitment,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage/commitment/aduit",
          name: "承诺书审核管理",
          component: CommitmentAduit,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage/category/index",
          name: "模板演示分类管理",
          component: Category,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage/customize/index",
          name: "自定义设置管理",
          component: Customize,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage/hotTeam/index",
          name: "热门队伍设置管理",
          component: HotTeam,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage/premium/index",
          name: "手续费设置",
          component: Premium,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage/teamlimit/index",
          name: "队伍最大金额限制管理",
          component: Teamlimit,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage/teamPayout/index",
          name: "提现记录统计管理",
          component: TeamPayout,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage/team/index",
          name: "队伍管理",
          component: Team,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage/team/premiumList",
          name: "队伍提现金额手续费管理",
          component: PremiumList,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage/team/admin",
          name: "队伍管理员管理",
          component: TeamAdmin,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage/teamOrder/index",
          name: "队伍订单管理",
          component: TeamOrder,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage/fag/index",
          name: "管理员常见问题设置管理",
          component: Fag,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage/teamManualPayout/index",
          name: "银行卡手动提现审核管理",
          component: TeamManualPayout,
          meta: {
            requireAuth: true
          }
        },{
          path: "/manage/versionrecord/index",
          name: "版本更新记录管理",
          component: Versionrecord,
          meta: {
            requireAuth: true
          }
        },
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js